'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldStageInitialMessage = exports.default = undefined;

var _reselect = require('reselect');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _getCurrentChannel = require('../../selectors/conversationSelectors/getCurrentChannel');

var _stubbedChannel = require('../constants/stubbedChannel');

var _historyDataForThread = require('../../thread-histories/selectors/historyDataForThread');

var getShouldStageInitialMessage = (0, _reselect.createSelector)([_getCurrentChannel.getCurrentChannel, _historyDataForThread.historyDataForThread], function (currentChannel, threadHistory) {
  if (currentChannel !== _stubbedChannel.STUBBED_CHANNEL) {
    return false;
  }

  return !threadHistory || !(0, _hasMessages.hasMessages)(threadHistory);
});

exports.default = getShouldStageInitialMessage;
exports.getShouldStageInitialMessage = getShouldStageInitialMessage;


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/getShouldStageInitialMessage.js
// module id = 671
// module chunks = 2 3